let Scroll = require('../components/Scroll');

class OnePage {
    constructor() {
        let sections   = document.querySelectorAll('main > section');
        this._sections = [];

        this._isTablet = window.innerWidth <= 1024;

        this._createArraySection(sections);

        this._currentIndex = this._currentSection();

        this._createListener();
    }

    _createListener() {
        let prevScroll = 0;
        let change     = false;

        window.addEventListener('scroll', () => {
            if (!this._isTablet) {

                let rect   = this._sections[this._currentIndex].getBoundingClientRect();
                let scroll = window.scrollY || window.pageYOffset;

                if (!change) {
                    if (prevScroll < scroll && this._bottomElementIsVisible(rect, scroll) && this._currentIndex + 1 < this._sections.length) {
                        this._currentIndex++;
                        change = true;
                    }
                    if (prevScroll > scroll && this._topElementIsVisible(rect, scroll) && this._currentIndex - 1 >= 0) {
                        this._currentIndex--;
                        change = true;
                    }
                }
                if (change) {
                    // Add here to remove on mobile
                    new Scroll().to(this._sections[this._currentIndex], () => {
                        change = false;
                    });
                }
                prevScroll = scroll;
            }
        });

        window.addEventListener('resize', () => {
            this._isTablet = window.innerWidth <= 1024;
            if (!this._isTablet) {
                new Scroll().to(this._sections[this._currentIndex]);
            }
        });
    }

    _currentSection() {
        let scrollPosition = window.screenY || window.pageYOffset;
        let i              = 0;
        for (let section of this._sections) {
            if (this._scrollIsInElement(scrollPosition, section)) {
                break;
            }
            i++
        }

        return i;
    }

    _createArraySection(sections) {
        for (let section of sections) {
            if (this._containSection(section)) {
                this._createArraySection(section.getElementsByTagName("section"))
            } else {
                this._sections.push(section);
            }
        }
    }

    _scrollIsInElement(scrollPosition, element) {
        let sectionRect   = element.getBoundingClientRect();
        let sectionTop    = sectionRect.top + scrollPosition;
        let sectionBottom = sectionTop + sectionRect.height;

        return scrollPosition >= sectionTop - 120 && scrollPosition < sectionBottom;
    }

    _topElementIsVisible(rect, scroll) {
        let top = rect.top + scroll;

        return top - 120 > scroll;
    }

    _bottomElementIsVisible(rect, scroll) {
        let top    = rect.top + scroll;
        let bottom = top + rect.height;

        return scroll + window.innerHeight >= bottom;
    }

    _containSection(node) {
        for (let child of node.children) {
            if (child.nodeName === 'SECTION') {
                return true;
            }
        }

        return false;
    }
}

module.exports = OnePage;